<template>
  <div>
    <div class="arrive-card">
      <h2>Customer arrived?</h2>
      <p>Find their booking to start charging</p>
      <button
        class="big-btn btn-white"
        @click="$emit('open-search')"
      >
        <v-icon>mdi-magnify</v-icon>
        Find Booking
      </button>
    </div>
    <div class="sec-label">
      Due now &amp; upcoming
    </div>
    <!--  -->
    <loader v-if="loading" />
    <!--  -->
    <div
      v-else-if="!list.length"
      class="empty-list"
    >
      <v-icon
        color="light-gray"
        x-large
      >
        mdi-lightning-bolt-outline
      </v-icon>

      <div>No upcoming bookings right now</div>
    </div>
    <div
      v-else
      class="list"
    >
      <div
        v-for="bk in list"
        :key="bk.booking_id"
        :class="[
          'bk-card',
          'bk-card--' + bk.current_status,
          {
            'bk-card--sel':
              selectedBooking && selectedBooking.booking_id === bk.booking_id,
          },
        ]"
        @click="$emit('open-booking', bk)"
      >
        <!-- <div class="stripe" /> -->
        <div class="bk-id-row">
          <span class="bk-id-badge">Booking No: {{ bk.booking_id }}</span>
        </div>
        <div class="bk-top">
          <div>
            <div class="bk-time">
              {{ bk.start_time_format }}
              <!-- <span class="ampm"> {{ bk.ampm }}</span> -->
            </div>
            <div class="bk-sub">
              {{ getDuration(bk.start_time) }}
            </div>
          </div>
          <span :class="['pill text-uppercase', pillClass(bk.current_status)]">
            <span class="dot" />
            {{ bk.current_status.replace("_", " ") }}
          </span>
        </div>
        <div class="bk-body">
          <div class="avatar">
            {{ bk.customer_name[0] }}
          </div>
          <div class="bk-info">
            <div class="bk-name">
              {{ bk.customer_name }}
            </div>
            <div class="bk-veh">
              <span class="reg-tag">{{ bk.vehicle_reg_no }} </span>
            </div>
            <div class="bk-veh-model">
              {{ bk.vehicle_make_name }} - {{ bk.vehicle_model_name }}
            </div>
          </div>
          <div class="bk-port">
            <div class="port-num">
              Gun-{{ bk.connector_no | returnAlpha }}
            </div>
            <div class="port-type">
              {{ bk.connector_type }} - {{ bk.connector_power }}kW
            </div>
          </div>
          <v-icon class="chev">
            mdi-chevron-right
          </v-icon>
        </div>
        <div class="bk-duration">
          <v-icon small>
            mdi-clock-time-three-outline
          </v-icon>
          {{ bk.slot_duration_minutes }} min booking slot &nbsp;·&nbsp; Until
          {{ bk.end_time_format }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { pillClass } from "../utils/bookingHelpers";

export default {
  name: "UpcomingTab",
  components: {
    Loader: () => import("../utils/Loader.vue"),
  },
  props: {
    selectedBooking: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      interval: null,
    };
  },
  computed: {
    ...mapGetters({
      loading: "bookingOperator/getLoading",
      list: "bookingOperator/getUpcoming",
    }),
  },
  beforeDestroy() {
    if (this.interval) {
      clearTimeout(this.interval);
      this.interval = null;
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    pillClass,
    fetchData() {
      clearTimeout(this.inverval);
      const params = { filter_type: "upcoming" };
      this.$store.dispatch(`bookingOperator/list`, params).then((data) => {
        if (data.length == 0) {
          return clearTimeout(this.interval);
        }
      });

      this.interval = setTimeout(this.fetchData, 15000);
    },
    getDuration(startTime) {
      const now = new Date();

      const [hours, minutes, seconds] = startTime.split(":").map(Number);

      const target = new Date();
      target.setHours(hours, minutes, seconds, 0);

      const diff = target.getTime() - now.getTime();
      const totalMinutes = Math.floor(diff / (1000 * 60));

      if (totalMinutes <= 0) {
        return "Started";
      }

      // Less than 1 hour
      if (totalMinutes < 60) {
        return `In ${totalMinutes} min${totalMinutes !== 1 ? "s" : ""}`;
      }

      // Hours & remaining minutes
      const hrs = Math.floor(totalMinutes / 60);
      const mins = totalMinutes % 60;

      if (mins === 0) {
        return `In ${hrs} Hour${hrs !== 1 ? "s" : ""}`;
      }

      return `In ${hrs} Hour${hrs !== 1 ? "s" : ""} and ${mins} min${
        mins !== 1 ? "s" : ""
      }`;
    },
  },
};
</script>
<style></style>
